<template>
  <div class="txt-wrap">
    <h1 class="modal-tit">{{ t('question_withdraw_sconchat') }}</h1>
    <span class="sub-txt">{{ t('not_restore_credits') }}</span>
  </div>

  <div class="btn-area vertical">
    <button type="button" class="l-btn primary-btn" @click="$emit('close')">
      <span>{{ t('label_think_again') }}</span>
    </button>
    <button type="button" class="l-btn gray-btn" @click="$emit('confirm')">
      <span>{{ t('label_delete_account_short') }}</span>
    </button>
  </div>
</template>

<script setup lang="ts">
defineEmits(['confirm', 'close']);

const { t } = useI18n();
</script>

<style scoped lang="scss">
.txt-wrap {
  padding: 1rem 0 2rem;
  .modal-tit {
    text-align: center;
  }
  .sub-txt {
    display: block;
    text-align: center;
    width: 100%;
    padding-top: $size-l;
    line-height: 140%;
    white-space: pre-wrap;
    color: $color-gray-100;
  }
}
.btn-area {
  &.vertical {
    display: flex;
    flex-direction: column;
    gap: $size-s;
  }
}
</style>
